module.exports = __webpack_public_path__ + "static/media/hero.544cee01.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/hero.png
// module id = 552
// module chunks = 0